/** @jsx h */
import { render, h } from 'preact';
import { track, VIEW, SUBMIT, CLICK } from '@updater-core/lib/tracker';
import { questions as defaultQuestions } from './constants';
import './app.global.css';

const randomizeOptionOrder = (options) =>
  options.sort((a, b) => (Math.random() > 0.5 ? -1 : 1));

defaultQuestions.options = randomizeOptionOrder(defaultQuestions.options);

export function buildApp(root, args) {
  const { goToNextStep, skip } = args;
  import('./survey').then(({ Survey }) => {
    track({
      verb: VIEW,
      object: 'improve_insurance',
    });

    if (
      !defaultQuestions.options.filter((question) => question.name === 'other')
        .length
    ) {
      defaultQuestions.options.push({
        label: `Other (please be specific)`,
        name: `other`,
      });
    }
    let questions = {
      ...defaultQuestions,
      options: defaultQuestions.options,
    };

    render(
      <Survey
        survey={questions}
        initiallyCheckedItems={[]}
        skip={skip}
        onNext={(state) => {
          goToNextStep();
        }}
        trackToggle={({ name, isSet }) =>
          track({
            verb: CLICK,
            object: 'improve_insurance_option',
            details: {
              name,
              currentValue: isSet,
            },
          })
        }
      />,
      root ? root : undefined
    );
  });
}
